<template>
  <div class="pagina-step Etapa4">
    <span class="pagina-step-title">{{ cidadeEstado }}</span>

    <div class="simulador-aps">
      <div class="simulador-filtros" ref="blocoSimuladorFiltros">
        <div class="simulador-filtros__top">
          <div class="simulador-filtros__content">
            <h3>
              <i class="icofont-sliders"></i>
              Informe as equipes por classificação
            </h3>

            <div class="simulador-filtros__buttons">
              <button
                v-for="item in filtrosList"
                :key="item"
                type="button"
                :class="{ active: filtros[item] }"
                @click="toggleFiltro(item)"
              >
                {{ item }}
              </button>
            </div>
          </div>

          <div class="simulador-estrato">
            <label>IED do município</label>
            <strong>{{ iedMunicipio }}</strong>
          </div>
        </div>

        <div
          v-if="equipesSelecionadas.length"
          class="simulador-equipes-quantidades"
        >
          <div
            v-for="equipe in equipesSelecionadas"
            :key="equipe"
            class="simulador-equipes-quantidades__item"
          >
            <label> Quantas equipes {{ equipe }} existem? </label>

            <input
              type="number"
              min="0"
              :value="quantidadesEquipes[equipe] || ''"
              @input="setQuantidadeEquipe(equipe, $event.target.value)"
            />
          </div>

          <div
            v-if="erroQuantidadeEquipes"
            class="simulador-equipes-quantidades__erro"
          >
            {{ erroQuantidadeEquipes }}
          </div>
        </div>
      </div>

      <div class="simulador-grid">
        <div
          v-for="(card, cardIndex) in cardsSimulador"
          :key="card.key"
          class="simulador-card"
          :class="card.key"
        >
          <div class="simulador-card__top"></div>

          <div class="simulador-card__body">
            <div class="simulador-card__title">
              <h4>{{ card.title }}</h4>
            </div>

            <div
              v-for="metric in card.metrics"
              :key="metric.label"
              class="simulador-metric"
            >
              <div
                class="simulador-metric__header"
                @click="toggleExpand(cardIndex, metric.label)"
              >
                <div class="simulador-metric__header-left">
                  <div class="simulador-metric__info">
                    <span class="plus">+</span>

                    <span class="qtd">
                      {{ quantidadeMetric(cardIndex, metric.label) }}
                    </span>

                    <strong>{{ getMetricLabel(metric.label) }}</strong>
                  </div>

                  <div class="simulador-metric__value">
                    =
                    {{
                      formatCurrency(valorMetric(card, cardIndex, metric.label))
                    }}
                  </div>
                </div>
              </div>

              <div
                v-if="expanded[`${cardIndex}-${metric.label}`]"
                class="simulador-submetrics"
              >
                <div
                  v-for="sub in getSubMetricsVisiveis(metric.label)"
                  :key="sub.label"
                  class="simulador-submetric"
                >
                  <div>
                    <span>+</span>

                    <input
                      type="number"
                      min="0"
                      :value="getQuantidade(cardIndex, metric.label, sub.label)"
                      @input="
                        setQuantidade(
                          cardIndex,
                          metric.label,
                          sub.label,
                          $event.target.value
                        )
                      "
                    />
                  </div>

                  <div class="simulador-submetric__text">
                    <span class="simulador-submetric__label">
                      {{ sub.label }}
                    </span>

                    <small class="simulador-submetric__price">
                      {{
                        formatCurrency(
                          getValorQualidade(metric.label, sub.label, card.key)
                        )
                      }}
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="simulador-card__footer">
              <div class="simulador-total">
                <span>=</span>
                <strong>{{
                  formatCurrency(totalCard(card, cardIndex))
                }}</strong>
              </div>

              <div v-if="card.key !== 'otima'" class="simulador-perda">
                <span>vs Ótimo</span>
                <strong
                  >- {{ formatCurrency(perdaCard(card, cardIndex)) }}</strong
                >
              </div>

              <div v-else class="simulador-otimo">
                <span>vs Ótimo</span>
                <i class="icofont-trophy"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="simulador-resultado">
        <p>
          O município recebe atualmente
          <strong class="simulador-resultado__valor-atual">
            {{ formatCurrency(totalReceber) }}
          </strong>
          mensais, distribuídos entre os componentes
          <strong>Equidade</strong> ({{ formatCurrency(totalEquidade) }}),
          <strong>CVAT</strong> ({{ formatCurrency(totalCVAT) }}) e
          <strong>Qualidade</strong> ({{ formatCurrency(totalQualidade) }}). Com
          a melhoria da classificação de todas as equipes para ÓTIMO, o repasse
          mensal pode aumentar em mais
          <strong class="simulador-resultado__valor-ganho">
            {{ formatCurrency(totalPerda) }} </strong
          >.
        </p>
      </div>

      <div class="simulador-resumo-progress">
        <div class="simulador-resumo-progress__row">
          <div class="simulador-resumo-progress__metric is-recebendo">
            <div class="simulador-resumo-progress__content">
              <span class="simulador-resumo-progress__label">Recebendo</span>
              <strong class="simulador-resumo-progress__value">
                {{ formatCurrency(totalReceber) }}
              </strong>
            </div>
          </div>

          <div class="simulador-resumo-progress__metric is-ganho">
            <div class="simulador-resumo-progress__content">
              <span class="simulador-resumo-progress__label"
                >Ganho potencial</span
              >
              <strong class="simulador-resumo-progress__value">
                + {{ formatCurrency(totalPerda) }}
              </strong>
            </div>
          </div>

          <div class="simulador-resumo-progress__metric is-maximo">
            <div class="simulador-resumo-progress__content">
              <span class="simulador-resumo-progress__label"
                >Máximo possível</span
              >
              <strong class="simulador-resumo-progress__value">
                = {{ formatCurrency(totalMaximo) }}
              </strong>
            </div>
          </div>
        </div>

        <div class="simulador-resumo-progress__bar" :title="progressTitle">
          <div class="simulador-resumo-progress__track"></div>
          <div
            class="simulador-resumo-progress__fill"
            :style="{ width: `${progressPercent}%` }"
          ></div>
          <div class="simulador-resumo-progress__caption">
            {{ progressPercent }}% do máximo
          </div>
        </div>
      </div>
    </div>

    <div class="container-buttons">
      <button type="button" @click="voltar">Voltar</button>
      <button type="button" @click="proximo">Avançar</button>
    </div>
  </div>
</template>

<script>
import { regras, getLabelRegra, equityValues, metricsSchema } from './utils'

export default {
  name: 'Etapa4',

  props: {
    dados: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      filtros: {
        CVAT: true,
        eSF: false,
        eSFR: false,
        eAP: false,
        eSB: false,
        eMulti: false,
        eCR: false,
        eAPP: false,
      },
      metricLabelsPorEquipe: {
        eSF: ['CVAT', 'eSF / eAP'],
        eSFR: ['CVAT', 'eSF / eAP'],
        eAP: ['CVAT', 'eSF / eAP'],
        eSB: ['eSB'],
        eMulti: ['eMulti'],
        eCR: ['eCR'],
        eAPP: ['eAPP'],
      },
      expanded: {},
      quantities: {},
      metricsSchema: { ...metricsSchema },
      equityValues: { ...equityValues },
      quantidadesEquipes: {},
      erroQuantidadeEquipes: '',
    }
  },

  computed: {
    cidadeEstado() {
      return `Quantidade de equipes por classificação em ${this.dados?.etapa1?.cidade?.no_municipio} - ${this.dados?.etapa1?.estado?.uf}`
    },

    iedMunicipio() {
      return this.dados?.etapa3?.ied?.value || '-'
    },

    filtrosList() {
      return ['eSF', 'eSFR', 'eAP', 'eSB', 'eMulti', 'eCR', 'eAPP']
    },

    metricasVisiveis() {
      const labelsAtivos = ['CVAT']

      if (this.filtros.eSF || this.filtros.eSFR || this.filtros.eAP) {
        labelsAtivos.push('eSF / eAP')
      }

      ;['eSB', 'eMulti', 'eCR', 'eAPP'].forEach((label) => {
        if (this.filtros[label]) {
          labelsAtivos.push(label)
        }
      })

      return labelsAtivos
        .map((label) => ({ label }))
        .filter((metric) => {
          return this.getSubMetricsVisiveis(metric.label).length
        })
    },

    estrato() {
      return Number(this.dados?.etapa3?.ied?.value || 1)
    },

    totalCVAT() {
      return this.calcularTotais().cvat
    },

    totalQualidade() {
      return this.calcularTotais().qualidade
    },

    totalEquidade() {
      return this.calcularTotais().equidade
    },

    totalPerda() {
      return this.calcularTotais().perda
    },

    totalReceber() {
      return this.totalCVAT + this.totalQualidade + this.totalEquidade
    },

    totalMaximo() {
      return this.totalReceber + this.totalPerda
    },

    progressPercent() {
      const max = Number(this.totalMaximo || 0)
      const atual = Number(this.totalReceber || 0)

      if (max <= 0) return 0

      return Math.max(0, Math.min(100, Math.round((atual / max) * 100)))
    },

    progressTitle() {
      return `${this.formatCurrency(
        this.totalReceber
      )} de ${this.formatCurrency(this.totalMaximo)}`
    },

    cardsBase() {
      return [
        { key: 'regular', metrics: [] },
        { key: 'suficiente', metrics: [] },
        { key: 'boa', metrics: [] },
        { key: 'otima', metrics: [] },
      ]
    },

    cardsSimulador() {
      const map = {
        regular: { title: 'Regular', factor: 0.25 },
        suficiente: { title: 'Suficiente', factor: 0.5 },
        boa: { title: 'Bom', factor: 0.75 },
        otima: { title: 'Ótimo', factor: 1 },
      }

      const ordem = ['regular', 'suficiente', 'boa', 'otima']

      return [...this.cardsBase]
        .sort((a, b) => {
          return ordem.indexOf(a.key) - ordem.indexOf(b.key)
        })
        .map((card) => {
          return {
            ...card,
            title: map[card.key]?.title || card.key,
            metrics: this.metricasVisiveis.map((metric) => ({
              ...metric,
              value: 0,
              isUserEquipe: false,
            })),
          }
        })
    },

    equipesSelecionadas() {
      return this.filtrosList.filter((item) => this.filtros[item])
    },
  },

  mounted() {
    this.preencherDadosSalvos()
  },

  methods: {
    /**
     * Preenche os dados salvos anteriormente na etapa 4.
     *
     * @returns {void}
     */
    preencherDadosSalvos() {
      const etapa4 = this.dados?.etapa4

      if (!etapa4) {
        return
      }

      if (etapa4.filtros) {
        Object.keys(this.filtros).forEach((key) => {
          this.$set(this.filtros, key, !!etapa4.filtros[key])
        })
      }

      if (etapa4.quantities) {
        Object.keys(etapa4.quantities).forEach((key) => {
          this.$set(this.quantities, key, etapa4.quantities[key])
        })
      }

      if (etapa4.quantidadesEquipes) {
        Object.keys(etapa4.quantidadesEquipes).forEach((key) => {
          this.$set(
            this.quantidadesEquipes,
            key,
            etapa4.quantidadesEquipes[key]
          )
        })
      }

      if (!etapa4.classificacoes) {
        return
      }

      Object.keys(etapa4.classificacoes).forEach((cardKey) => {
        const cardIndex = this.cardsSimulador.findIndex((card) => {
          return card.key === cardKey
        })

        if (cardIndex === -1) {
          return
        }

        Object.keys(etapa4.classificacoes[cardKey]).forEach((metricLabel) => {
          Object.keys(etapa4.classificacoes[cardKey][metricLabel]).forEach(
            (subLabel) => {
              const key = this.getQuantidadeKey(
                cardIndex,
                metricLabel,
                subLabel
              )

              this.$set(
                this.quantities,
                key,
                etapa4.classificacoes[cardKey][metricLabel][subLabel]
              )
            }
          )
        })
      })
    },

    /**
     * Alterna a exibição dos detalhes da métrica.
     * Ao abrir um dropdown, fecha todos os outros.
     *
     * @param {Number} cardIndex
     * @param {String} metricLabel
     * @returns {void}
     */
    toggleExpand(cardIndex, metricLabel) {
      const key = `${cardIndex}-${metricLabel}`
      const isAbrindo = !this.expanded[key]

      if (isAbrindo) {
        Object.keys(this.expanded).forEach((k) => {
          if (this.expanded[k]) {
            this.$set(this.expanded, k, false)
          }
        })
      }

      this.$set(this.expanded, key, isAbrindo)
    },

    /**
     * Ativa ou desativa um filtro.
     *
     * @param {String} filtro
     * @returns {void}
     */
    toggleFiltro(filtro) {
      this.$set(this.filtros, filtro, !this.filtros[filtro])
    },

    /**
     * Retorna as submétricas de uma métrica.
     *
     * @param {String} metricLabel
     * @returns {Array}
     */
    getSubMetrics(metricLabel) {
      return this.metricsSchema[metricLabel] || []
    },

    /**
     * Retorna as submétricas visíveis conforme os filtros ativos.
     *
     * @param {String} metricLabel
     * @returns {Array}
     */
    getSubMetricsVisiveis(metricLabel) {
      return this.getSubMetrics(metricLabel).filter((sub) => {
        if (sub.label === 'eSF' && !this.filtros.eSF) return false
        if (sub.label === 'eSFR' && !this.filtros.eSFR) return false
        if (sub.label.includes('eAP') && !this.filtros.eAP) return false
        if (sub.label.includes('eSB') && !this.filtros.eSB) return false
        if (sub.label.includes('eMulti') && !this.filtros.eMulti) return false
        if (sub.label.includes('eCR') && !this.filtros.eCR) return false
        if (
          [
            'Essencial 20h',
            'Essencial 30h',
            'Ampliada 20h',
            'Ampliada 30h',
          ].includes(sub.label) &&
          !this.filtros.eAPP
        ) {
          return false
        }

        return true
      })
    },

    /**
     * Monta a chave usada para armazenar a quantidade.
     *
     * @param {Number} cardIndex
     * @param {String} metricLabel
     * @param {String} subLabel
     * @returns {String}
     */
    getQuantidadeKey(cardIndex, metricLabel, subLabel) {
      return `${cardIndex}-${metricLabel}-${subLabel}`
    },

    /**
     * Retorna a quantidade preenchida.
     *
     * @param {Number} cardIndex
     * @param {String} metricLabel
     * @param {String} subLabel
     * @returns {Number|String}
     */
    getQuantidade(cardIndex, metricLabel, subLabel) {
      const key = this.getQuantidadeKey(cardIndex, metricLabel, subLabel)
      return this.quantities[key] === undefined ? 0 : this.quantities[key]
    },

    /**
     * Define a quantidade preenchida.
     *
     * @param {Number} cardIndex
     * @param {String} metricLabel
     * @param {String} subLabel
     * @param {String|Number} value
     * @returns {void}
     */
    setQuantidade(cardIndex, metricLabel, subLabel, value) {
      const key = this.getQuantidadeKey(cardIndex, metricLabel, subLabel)
      const quantidade = value === '' ? '' : Math.max(0, Number(value || 0))

      this.$set(this.quantities, key, quantidade)
    },

    /**
     * Retorna a quantidade total de uma métrica no card.
     *
     * @param {Number} cardIndex
     * @param {String} metricLabel
     * @returns {Number}
     */
    quantidadeMetric(cardIndex, metricLabel) {
      return this.getSubMetricsVisiveis(metricLabel).reduce((total, sub) => {
        return (
          total +
          Number(this.getQuantidade(cardIndex, metricLabel, sub.label) || 0)
        )
      }, 0)
    },

    /**
     * Calcula o total financeiro de um card.
     *
     * @param {Object} card
     * @param {Number} cardIndex
     * @returns {Number}
     */
    totalCard(card, cardIndex) {
      return card.metrics.reduce((total, metric) => {
        return (
          total +
          this.getSubMetricsVisiveis(metric.label).reduce((subtotal, sub) => {
            const quantidade = Number(
              this.getQuantidade(cardIndex, metric.label, sub.label) || 0
            )

            const valor = this.getValorQualidade(
              metric.label,
              sub.label,
              card.key
            )

            return subtotal + quantidade * valor
          }, 0)
        )
      }, 0)
    },

    /**
     * Monta as classificações detalhadas.
     *
     * @returns {Object}
     */
    montarClassificacoes() {
      return this.cardsSimulador.reduce((acc, card, cardIndex) => {
        acc[card.key] = {}

        this.metricasVisiveis.forEach((metric) => {
          acc[card.key][metric.label] = {}

          this.getSubMetricsVisiveis(metric.label).forEach((sub) => {
            acc[card.key][metric.label][sub.label] = Number(
              this.getQuantidade(cardIndex, metric.label, sub.label) || 0
            )
          })
        })

        return acc
      }, {})
    },

    /**
     * Monta os totais por equipe e os itens detalhados
     * para uso no relatório final.
     *
     * Para cada classificação, considera apenas a maior
     * quantidade encontrada para cada subequipe, evitando
     * duplicidade entre componentes na mesma classificação.
     *
     * @returns {Object}
     */
    montarTotaisPorEquipe() {
      const totais = {}
      const itens = []

      this.cardsSimulador.forEach((card, cardIndex) => {
        const totaisDoCard = {}

        card.metrics.forEach((metric) => {
          this.getSubMetricsVisiveis(metric.label).forEach((sub) => {
            const quantidade = Number(
              this.getQuantidade(cardIndex, metric.label, sub.label) || 0
            )

            if (quantidade <= 0) {
              return
            }

            const valorUnitario = this.getValorQualidade(
              metric.label,
              sub.label,
              card.key
            )

            const valorTotal = quantidade * valorUnitario

            itens.push({
              componente: metric.label,
              equipe: sub.label,
              classificacao: card.key,
              classificacaoLabel: card.title,
              quantidade,
              valorUnitario,
              valorTotal,
            })

            if (!totaisDoCard[sub.label]) {
              totaisDoCard[sub.label] = 0
            }

            totaisDoCard[sub.label] = Math.max(
              totaisDoCard[sub.label],
              quantidade
            )
          })
        })

        Object.keys(totaisDoCard).forEach((label) => {
          if (!totais[label]) {
            totais[label] = 0
          }

          totais[label] += totaisDoCard[label]
        })
      })

      return {
        totais,
        itens,
      }
    },

    /**
     * Retorna o valor da equipe conforme classificação usando as regras.
     *
     * @param {String} metricLabel
     * @param {String} subLabel
     * @param {String} cardKey
     * @returns {Number}
     */
    getValorQualidade(metricLabel, subLabel, cardKey) {
      const classificacoes = {
        regular: 'Regular',
        suficiente: 'Suficiente',
        boa: 'Bom',
        otima: 'Ótimo',
      }

      const tipoClassificacao = classificacoes[cardKey]

      const listaRegras =
        metricLabel === 'CVAT'
          ? regras.vinculo_e_acompanhamento
          : regras.qualidade

      const regra = listaRegras.find((item) => {
        return item.label === getLabelRegra(subLabel)
      })

      if (!regra) {
        return 0
      }

      const classificacao = regra.classificacao.find((item) => {
        return item.tipo === tipoClassificacao
      })

      return Number(classificacao?.valor || 0)
    },

    /**
     * Calcula a perda do card em relação ao ótimo.
     *
     * @param {Object} card
     * @param {Number} cardIndex
     * @returns {Number}
     */
    perdaCard(card, cardIndex) {
      if (card.key === 'otima') {
        return 0
      }

      return card.metrics.reduce((total, metric) => {
        return (
          total +
          this.getSubMetricsVisiveis(metric.label).reduce((subtotal, sub) => {
            const quantidade = Number(
              this.getQuantidade(cardIndex, metric.label, sub.label) || 0
            )

            const valorAtual = this.getValorQualidade(
              metric.label,
              sub.label,
              card.key
            )

            const valorOtimo = this.getValorQualidade(
              metric.label,
              sub.label,
              'otima'
            )

            return subtotal + quantidade * (valorOtimo - valorAtual)
          }, 0)
        )
      }, 0)
    },

    /**
     * Soma o total por métrica e retorna o maior total encontrado.
     *
     * Usado para evitar duplicidade entre CVAT e Qualidade quando
     * representam as mesmas equipes, como eSF, eSFR e eAP.
     *
     * @param {Array} subLabels
     * @param {Array} metricLabels
     * @returns {Number}
     */
    somarTotalPorEquipe(subLabels, metricLabels = []) {
      const totaisPorMetrica = metricLabels.map((metricLabel) => {
        return this.cardsSimulador.reduce((total, _card, cardIndex) => {
          const totalSubLabels = subLabels.reduce((sum, subLabel) => {
            const key = this.getQuantidadeKey(cardIndex, metricLabel, subLabel)

            return sum + Number(this.quantities?.[key] || 0)
          }, 0)

          return total + totalSubLabels
        }, 0)
      })

      return Math.max(...totaisPorMetrica, 0)
    },

    /**
     * Calcula o valor total da métrica no card.
     *
     * @param {Object} card
     * @param {Number} cardIndex
     * @param {String} metricLabel
     * @returns {Number}
     */
    valorMetric(card, cardIndex, metricLabel) {
      return this.getSubMetricsVisiveis(metricLabel).reduce((total, sub) => {
        const quantidade = Number(
          this.getQuantidade(cardIndex, metricLabel, sub.label) || 0
        )

        const valor = this.getValorQualidade(metricLabel, sub.label, card.key)

        return total + quantidade * valor
      }, 0)
    },

    /**
     * Calcula o valor total da Equidade.
     *
     * Para eSF, eSFR e eAP, considera apenas a quantidade única
     * de equipes, utilizando o maior total entre CVAT e Qualidade.
     *
     * @returns {number}
     */
    calcularEquidade() {
      const valorESF = this.equityValues.eSF[this.estrato - 1]
      const valorEAP30h = this.equityValues.eAP30h[this.estrato - 1]
      const valorEAP20h = this.equityValues.eAP20h[this.estrato - 1]

      const totalESF = this.filtros.eSF
        ? this.somarTotalPorEquipe(['eSF'], ['CVAT', 'eSF / eAP'])
        : 0

      const totalEAP30h = this.filtros.eAP
        ? this.somarTotalPorEquipe(['eAP 30h'], ['CVAT', 'eSF / eAP'])
        : 0

      const totalEAP20h = this.filtros.eAP
        ? this.somarTotalPorEquipe(['eAP 20h'], ['CVAT', 'eSF / eAP'])
        : 0

      return (
        totalESF * valorESF +
        totalEAP30h * valorEAP30h +
        totalEAP20h * valorEAP20h
      )
    },

    /**
     * Calcula os totais gerais do simulador.
     *
     * @returns {Object}
     */
    calcularTotais() {
      let cvat = 0
      let qualidade = 0
      let equidade = 0
      let perda = 0

      this.cardsSimulador.forEach((card, cardIndex) => {
        card.metrics.forEach((metric) => {
          this.getSubMetricsVisiveis(metric.label).forEach((sub) => {
            const quantidade = Number(
              this.getQuantidade(cardIndex, metric.label, sub.label) || 0
            )

            const valorAtual =
              quantidade *
              this.getValorQualidade(metric.label, sub.label, card.key)

            const valorMaximo =
              quantidade *
              this.getValorQualidade(metric.label, sub.label, 'otima')

            if (metric.label === 'CVAT') {
              cvat += valorAtual
            } else {
              qualidade += valorAtual
            }
            if (card.key !== 'otima') {
              perda += valorMaximo - valorAtual
            }
          })
        })
      })

      equidade = this.calcularEquidade()

      return { cvat, qualidade, equidade, perda }
    },

    /**
     * Formata valores em moeda brasileira.
     *
     * @param {Number} value
     * @returns {String}
     */
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(Number(value || 0))
    },

    /**
     * Salva os dados da etapa.
     *
     * @returns {void}
     */
    salvarDados() {
      const totais = this.calcularTotais()
      const equipes = this.montarTotaisPorEquipe()

      this.$emit('dados-etapa', {
        etapa: 'etapa4',
        dados: {
          ied: this.estrato,
          filtros: this.filtros,
          quantities: this.quantities,
          quantidadesEquipes: this.quantidadesEquipes,
          classificacoes: this.montarClassificacoes(),

          equipes: equipes.itens,
          totaisEquipes: equipes.totais,

          totalCVAT: totais.cvat,
          totalQualidade: totais.qualidade,
          totalEquidade: totais.equidade,
          totalPerda: totais.perda,
          totalReceber: this.totalReceber,
          totalMaximo: this.totalMaximo,

          ...equipes.totais,
        },
      })
    },

    /**
     * Define a quantidade total informada para o tipo de equipe selecionado.
     *
     * @param {String} equipe
     * @param {String|Number} value
     * @returns {void}
     */
    setQuantidadeEquipe(equipe, value) {
      const quantidade = value === '' ? '' : Math.max(0, Number(value || 0))

      this.$set(this.quantidadesEquipes, equipe, quantidade)
      this.erroQuantidadeEquipes = ''
    },

    /**
     * Retorna os sublabels relacionados ao tipo de equipe.
     *
     * @param {String} equipe
     * @returns {Array}
     */
    getSubLabelsPorEquipe(equipe) {
      const map = {
        eSF: ['eSF'],
        eSFR: ['eSFR'],
        eAP: ['eAP 20h', 'eAP 30h'],
        eSB: [
          'eSB I - Comum',
          'eSB I - Quil/Assent',
          'eSB II - Comum',
          'eSB II - Quil/Assent',
        ],
        eMulti: ['Estratégica', 'Complementar', 'Ampliada'],
        eCR: ['eCR I', 'eCR II', 'eCR III'],
        eAPP: [
          'Essencial 20h',
          'Essencial 30h',
          'Ampliada 20h',
          'Ampliada 30h',
        ],
      }

      return map[equipe] || []
    },

    /**
     * Valida se a quantidade informada para cada tipo de equipe
     * corresponde à quantidade distribuída entre as classificações.
     *
     * Para equipes compartilhadas entre CVAT e Qualidade, utiliza
     * o maior total entre os componentes para evitar dupla contagem.
     *
     * @returns {Boolean}
     */
    validarQuantidadeEquipes() {
      for (const equipe of this.equipesSelecionadas) {
        const valorInformado = this.quantidadesEquipes[equipe]

        // Campo não preenchido
        if (
          valorInformado === '' ||
          valorInformado === undefined ||
          valorInformado === null
        ) {
          this.erroQuantidadeEquipes = `Informe a quantidade de equipes ${equipe}.`

          return false
        }

        const quantidadeInformada = Number(valorInformado)

        const quantidadeNosCards = this.somarTotalPorEquipe(
          this.getSubLabelsPorEquipe(equipe),
          this.metricLabelsPorEquipe[equipe]
        )
        if (quantidadeInformada !== quantidadeNosCards) {
          this.erroQuantidadeEquipes = `A quantidade de ${equipe} informada é ${quantidadeInformada}, mas foram distribuídas ${quantidadeNosCards} nos cards.`

          return false
        }
      }

      this.erroQuantidadeEquipes = ''

      return true
    },

    /**
     * Faz scroll até a área de validação das equipes.
     *
     * @returns {void}
     */
    scrollParaSimuladorFiltros() {
      this.$nextTick(() => {
        const el = this.$refs.blocoSimuladorFiltros

        if (!el) {
          return
        }

        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      })
    },

    /**
     * Volta para a etapa anterior.
     *
     * @returns {void}
     */
    voltar() {
      this.salvarDados()
      this.$emit('etapa-anterior')
    },

    /**
     * Avança para a próxima etapa.
     *
     * @returns {void}
     */
    proximo() {
      if (!this.validarQuantidadeEquipes()) {
        this.scrollParaSimuladorFiltros()
        return
      }

      this.salvarDados()
      this.$emit('proxima-etapa')
    },

    /**
     * Retorna o título exibido para a métrica.
     *
     * @param {String} metricLabel
     * @returns {String}
     */
    getMetricLabel(metricLabel) {
      if (metricLabel === 'eSF / eAP') {
        return this.filtros.eAP ? 'eSF / eAP' : 'eSF'
      }

      return metricLabel
    },
  },
}
</script>

<style scoped lang="scss" src="./styles.scss" />

<style lang="scss">
.Etapa4 {
  height: auto !important;

  .simulador-aps {
    margin-bottom: 40px;
  }

  .simulador-filtros {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    margin-bottom: 28px;
    display: flex;
    flex-direction: column;
    border: 1px solid #e2e8f0;
  }

  .simulador-filtros__top {
    display: flex;
    justify-content: space-between;
    gap: 24px;
  }

  .simulador-filtros h3 {
    font-size: 18px;
    font-weight: 900;
    color: #0f172a;
    margin: 0 0 14px;
  }

  .simulador-filtros__buttons,
  .simulador-estrato__buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .simulador-filtros button,
  .simulador-estrato button {
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    color: #94a3b8;
    border-radius: 12px;
    padding: 8px 14px;
    font-size: 12px;
    font-weight: 900;
    width: auto;
    box-shadow: none;
    text-transform: initial;
  }

  .simulador-filtros button.active,
  .simulador-estrato button.active {
    background: #3f84b6;
    border-color: #3f84b6;
    color: #fff;
  }

  .simulador-filtros__content {
    flex: 1;
    min-width: 0;
  }

  .simulador-equipes-quantidades {
    margin-top: 18px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 12px;
  }

  .simulador-equipes-quantidades__item {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 12px;
  }

  .simulador-equipes-quantidades__item label {
    display: block;
    font-size: 12px;
    font-weight: 900;
    color: #64748b;
    margin-bottom: 6px;
  }

  .simulador-equipes-quantidades__item input {
    width: 100%;
    height: 36px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 6px 10px;
    font-weight: 900;
  }

  .simulador-equipes-quantidades__erro {
    grid-column: 1 / -1;
    color: #dc2626;
    font-size: 13px;
    font-weight: 900;
  }

  .simulador-estrato {
    min-width: 260px;
    background: #f8fafc;
    border-radius: 18px;
    padding: 16px;
  }

  .simulador-estrato label {
    display: block;
    font-size: 13px;
    font-weight: 900;
    color: #64748b;
    margin-bottom: 10px;
  }

  .simulador-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 24px;
  }

  .simulador-card {
    background: #fff;
    border-radius: 24px;
    overflow: hidden;
    border: 1px solid #f1f5f9;
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
  }

  .simulador-card__top {
    height: 12px;
  }

  .simulador-card.regular .simulador-card__top {
    background: #ce7000;
  }

  .simulador-card.suficiente .simulador-card__top {
    background: #d1a100;
  }

  .simulador-card.boa .simulador-card__top {
    background: #00a972;
  }

  .simulador-card.otima .simulador-card__top {
    background: #3f84b6;
  }

  .simulador-card__body {
    padding: 22px;
  }

  .simulador-card__title {
    text-align: center;
    margin-bottom: 20px;
  }

  .simulador-card__title span {
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #94a3b8;
  }

  .simulador-card__title h4 {
    margin: 4px 0 0;
    font-size: 24px;
    font-weight: 900;
  }

  .simulador-metric {
    border-bottom: 1px solid #f1f5f9;
    padding: 10px 0;
  }

  .simulador-metric__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .simulador-metric__header > div {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .simulador-metric__header-left {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 12px;
  }

  .simulador-metric__info {
    display: flex;
    align-items: center;
    gap: 10px;
    strong {
      font-size: 12px;
    }
  }

  .simulador-metric__value {
    font-size: 12px;
    font-weight: 900;
    color: #0f172a;
    white-space: nowrap;
  }

  .plus {
    color: #cbd5e1;
    font-weight: 900;
    font-size: 18px;
  }

  .qtd {
    width: 48px;
    height: 32px;
    border-radius: 10px;
    background: #eff6ff;
    color: #3f84b6;
    border: 1px solid #dbeafe;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 900;
  }

  .simulador-submetrics {
    margin-top: 12px;
    margin-left: 22px;
    padding-left: 14px;
    border-left: 2px solid #e2e8f0;
  }

  .simulador-submetric {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    column-gap: 10px;
    margin-bottom: 12px;
    padding: 4px 0;
  }

  .simulador-submetric > div:first-child {
    display: grid;
    grid-template-columns: 14px 44px;
    align-items: center;
    gap: 10px;
  }

  .simulador-submetric__text {
    display: flex !important;
    flex-direction: column;
    min-width: 0;
    line-height: 1.2;
  }

  .simulador-submetric__label {
    font-size: 12px;
    font-weight: 800;
    color: #64748b;
    white-space: nowrap;
  }

  .simulador-submetric__price {
    font-size: 11px;
    font-weight: 900;
    color: #94a3b8;
    margin-top: 2px;
    white-space: nowrap;
  }

  .simulador-submetric input {
    width: 44px !important;
    min-width: 44px !important;
    max-width: 44px !important;
    height: 28px !important;
    border: 1px solid #e2e8f0 !important;
    background: #f8fafc !important;
    border-radius: 7px !important;
    padding: 4px !important;
    text-align: center !important;
    font-size: 11px !important;
    font-weight: 900 !important;
    color: #64748b !important;
    box-shadow: none !important;
    margin: 0 !important;
  }

  .simulador-card__footer {
    margin-top: 22px;
    padding-top: 16px;
    border-top: 2px dashed #f1f5f9;
  }

  .simulador-total,
  .simulador-perda,
  .simulador-otimo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 16px;
    padding: 14px;
    margin-top: 10px;
    font-weight: 900;
  }

  .simulador-total {
    background: #f8fafc;
  }

  .simulador-perda {
    background: #fef2f2;
    color: #dc2626;
  }

  .simulador-otimo {
    background: #f0fdf4;
    color: #15803d;
  }

  .simulador-resultado {
    margin-top: 28px;
    background: #fff;
    border-left: 8px solid #3f84b6;
    border-radius: 28px;
    padding: 28px;
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  }

  .simulador-resultado p {
    margin: 0;
    font-size: 18px;
    color: #334155;
    line-height: 1.6;
  }

  .simulador-resultado__valor-atual {
    color: #16a34a;
  }

  .simulador-resultado__valor-ganho {
    color: #f59e0b;
  }

  .simulador-resumo-progress {
    margin-top: 22px;
    background: rgba(255, 255, 255, 0.72);
    border: 1px solid #f1f5f9;
    border-radius: 24px;
    padding: 16px 18px 18px;
  }

  .simulador-resumo-progress__row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 18px;
    align-items: start;
  }

  .simulador-resumo-progress__metric {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .simulador-resumo-progress__content {
    display: flex;
    flex-direction: column;
    gap: 7px;
    min-width: 0;
  }

  .simulador-resumo-progress__label {
    display: block;
    font-size: 12px;
    font-weight: 900;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .simulador-resumo-progress__value {
    font-size: 28px;
    font-weight: 900;
    margin: 0;
    line-height: 1.1;
  }

  .simulador-resumo-progress__metric.is-recebendo
    .simulador-resumo-progress__value {
    color: #16a34a;
  }

  .simulador-resumo-progress__metric.is-ganho
    .simulador-resumo-progress__value {
    color: #f59e0b;
  }

  .simulador-resumo-progress__metric.is-maximo
    .simulador-resumo-progress__value {
    color: #354abb;
  }

  .simulador-resumo-progress__bar {
    position: relative;
    margin-top: 14px;
    padding-top: 12px;
  }

  .simulador-resumo-progress__track {
    height: 10px;
    background: #e2e8f0;
    border-radius: 999px;
    overflow: hidden;
  }

  .simulador-resumo-progress__fill {
    position: absolute;
    left: 0;
    top: 12px;
    height: 10px;
    background: linear-gradient(90deg, #16a34a 0%, #f59e0b 55%, #354abb 100%);
    border-radius: 999px;
    transition: width 180ms ease;
  }

  .simulador-resumo-progress__caption {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 900;
    color: #64748b;
    text-align: right;
  }

  @media (max-width: 768px) {
    .simulador-filtros__top {
      flex-direction: column;
    }

    .simulador-estrato {
      width: 100%;
      min-width: 100%;
    }

    .simulador-resumo-progress__row {
      grid-template-columns: 1fr;
    }
  }
}
</style>
